import { useEffect, useRef } from 'react';

const KONAMI_CODE_KEYS = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
];

export const useKonamiCode = (callback: VoidFunction): void => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    let pressedKeys: string[] = [];

    const listener = ({ key }: KeyboardEvent) => {
      pressedKeys = [...pressedKeys.slice(-KONAMI_CODE_KEYS.length + 1), key];

      const isEveryKeyPressed =
        pressedKeys.length === KONAMI_CODE_KEYS.length &&
        pressedKeys.every(
          (pressed, index) => pressed === KONAMI_CODE_KEYS[index],
        );

      if (isEveryKeyPressed) {
        pressedKeys = [];
        callbackRef.current();
      }
    };

    document.addEventListener('keyup', listener);

    return () => document.removeEventListener('keyup', listener);
  }, []);
};
